import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {  API_CREATE_ACCOUNT, API_DELETE_ACCOUNT, API_DELETE_DEPARTMENT, API_GET_ACCOUNT_LIST, API_GET_ACCOUNT_LIST_BY_ENTITY, API_UPDATE_ACCOUNT } from "../../../shared/routes/private.routes";

const config = {
  name: "account",
};

export const getAccountsList: any = createAsyncThunk(
  `${config.name}/getAccountList`,
  async ({params, body}: any) => {
    return Client.post(API_GET_ACCOUNT_LIST, body, {params});
  }
);

export const createAccount: any = createAsyncThunk(
  `${config.name}/create-accounts`,
  async (formData: FormData) => {
    return Client.post(API_CREATE_ACCOUNT, formData);
  }
);

export const deleteAccount: any = createAsyncThunk(
  `${config.name}/delete-account`,
  async (accountId: string) => {
    return Client.delete(API_DELETE_ACCOUNT+`${accountId}`);
  }
);

export const updateAccountById: any = createAsyncThunk(
  `${config.name}/update-account`,
  async ({ accountId, formData }: { accountId: string, formData: FormData }) => {
    const url = API_UPDATE_ACCOUNT + `${accountId}`;
    return Client.put(url, formData);
  }
);

export const getAccountsByEntity: any = createAsyncThunk(
  `${config.name}/getAccountsByEntity`,
  async (accountId: string) => {
    return Client.get(API_GET_ACCOUNT_LIST_BY_ENTITY+`${accountId}`);
  }
);

export const accountsReducer = createSlice({
  name: config.name,
  initialState: {
    loadingAccount: false as any,
    accountList: [] as any, 
    filters: {} as any, 
    pagination: {page: 0, limit: TABLE_ROWS_COUNT, total: 0}
  },
  reducers: {
    resetAccount: (state) => {
      state.loadingAccount = false;
      state.accountList = [];
      state.filters = {};
      state.pagination = {page: 0, limit: TABLE_ROWS_COUNT, total: 0};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAccountsList.pending, (state) => {
        state.loadingAccount = true;
        state.accountList = [] as any;
      })
      .addCase(getAccountsList.fulfilled, (state, action) => {
        state.loadingAccount = false;
        state.accountList = action?.payload?.data?.data as any;
        state.pagination = {page: action?.payload?.data?.page, limit: action?.payload?.data?.limit, total: action?.payload?.data?.total}
      })
      .addCase(getAccountsList.rejected, (state) => {
        state.loadingAccount = false;
        state.accountList = [] as any;
      })
  },
});

export const { resetAccount } = accountsReducer.actions;
export default accountsReducer.reducer;
